/** @prettier */
import { call, takeEvery } from 'redux-saga/effects';

import {
  OFFER_SUBMISSION_FAILURE,
  OFFER_SUBMISSION_SUCCESS,
} from '@xanadu/ui-shared/modules/unsubmittedOffers/actions';
import {
  REGISTRATION_FAILURE,
  REGISTRATION_SUCCESS,
} from '@xanadu/ui-shared/modules/userRegistration/actions';
import {
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
} from '@xanadu/ui-shared/modules/userSession/actions';

import { trackEvent } from '../../utils/analytics';

const getBetData = ({ payload = {} }) => ({
  side: payload.side,
  sportId: payload.sportId,
  product: payload.product,
});

const EVENTS = {
  [LOGIN_SUCCESS]: ({ payload = {} }) => (payload.isLogin ? ['Login'] : null),
  [LOGIN_FAILURE]: () => ['Login Failed'],
  [LOGOUT_SUCCESS]: () => ['Logout'],
  [REGISTRATION_SUCCESS]: () => ['Registration Completed'],
  [REGISTRATION_FAILURE]: () => ['Registration Failed'],
  [OFFER_SUBMISSION_SUCCESS]: (action) => ['Bet Placed', getBetData(action)],
  [OFFER_SUBMISSION_FAILURE]: (action) => ['Bet Failed', getBetData(action)],
};

export function* trackAction(action) {
  const event = EVENTS[action.type](action);

  if (event) {
    yield call(trackEvent, ...event);
  }
}

export default function* analyticsSagas() {
  yield takeEvery(Object.keys(EVENTS), trackAction);
}
